import { render, staticRenderFns } from "./SplitPanelPage.vue?vue&type=template&id=79a302dc&scoped=true&"
import script from "./SplitPanelPage.vue?vue&type=script&lang=js&"
export * from "./SplitPanelPage.vue?vue&type=script&lang=js&"
import style0 from "./SplitPanelPage.vue?vue&type=style&index=0&id=79a302dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a302dc",
  null
  
)

export default component.exports